module.exports = __webpack_public_path__ + "img/6C.dc1e4d33.svg";